var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcessingStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.35703 12.2324C2.37628 11.9745 2.60097 11.781 2.85888 11.8003L6.12524 12.114C6.38316 12.1333 6.57663 12.358 6.55737 12.6159C6.53812 12.8738 6.31343 13.0673 6.05552 13.048L4.07877 12.8305C5.2358 13.758 6.70387 14.3122 8.3017 14.3122C12.0337 14.3122 15.059 11.2869 15.059 7.55493C15.059 7.29629 15.2687 7.08663 15.5273 7.08663C15.7859 7.08663 15.9956 7.29629 15.9956 7.55493C15.9956 11.8042 12.5509 15.2488 8.3017 15.2488C6.35136 15.2488 4.57024 14.5227 3.2145 13.3271L2.97726 15.5685C2.958 15.8264 2.73331 16.0199 2.4754 16.0006C2.21749 15.9814 2.02401 15.7567 2.04327 15.4988L2.35703 12.2324Z",
    fill: "#147582"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8535 3.78C13.851 4.03862 13.6392 4.24619 13.3806 4.24362L10.1028 4.20173C9.84414 4.19916 9.63657 3.98742 9.63914 3.72881C9.64171 3.47019 9.85345 3.26262 10.1121 3.26519L12.0968 3.29422C10.8823 2.44335 9.38153 1.98502 7.78703 2.08813C4.06285 2.32895 1.23903 5.54323 1.47986 9.26742C1.49655 9.52551 1.30085 9.74826 1.04276 9.76495C0.784666 9.78164 0.561911 9.58595 0.545222 9.32785C0.271015 5.08749 3.48622 1.4277 7.72659 1.15349C9.67287 1.02763 11.4971 1.63728 12.9272 2.74297L12.9589 0.492846C12.9614 0.234227 13.1732 0.0266592 13.4318 0.0292297C13.6904 0.0317999 13.898 0.243535 13.8954 0.502154L13.8535 3.78Z",
    fill: "#147582"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessingStatus);
export default __webpack_public_path__ + "static/media/processingStatus.1df1f83fa4db1f09a3f3022a22291774.svg";
export { ForwardRef as ReactComponent };